import { SignDocumentComponent } from './sign-document/sign-document.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentRoutingModule } from './document-routing.module';
import { AddDocumentComponent } from './add-document/add-document.component';
import { SearchDocumentComponent } from './search-document/search-document.component';
import { DocumentGroupManageComponent } from './document-group-manage/document-group-manage.component';
import { SearchDocumentSignComponent } from './search-document-sign/search-document-sign.component';
import { ApprovedContractMohaComponent } from './approved-contract-moha/approved-contract-moha.component';
import { SearchDocumentReceiveComponent } from './search-document-receive/search-document-receive.component';
import { MaterialModule } from 'src/app/core/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatAutocompleteModule, MatCheckboxModule, MatProgressBarModule, MatRadioModule } from '@angular/material';
import { NgMatAutocompleteModule } from 'src/app/shared/components/autocomplete/autocomplete.module';
import { DisplayTemplateComponent } from './display-template/display-template.component';
import { PanelDocumentComponent } from './panel-document/panel-document.component';
import { NgxMaskModule } from 'ngx-mask';
import { MatInputModule } from '@angular/material';
import { ViewDocumentComponent } from './view-document/view-document.component';
import { UpdateInformationDialogComponent } from './view-document/update-information-dialog/update-information-dialog.component';
import { NegotiationFormComponent } from './view-document/update-information-dialog/negotiation-form/negotiation-form.component';
import { NegotiationFormTemplateComponent } from './view-document/update-information-dialog/negotiation-form/form-template/negotiation-form-template.component';
import { SubmissionComponent } from './submission/submission.component';
import { PanelDocumentViewComponent } from './panel-document-view/panel-document-view.component';
import { RejectDocumentComponent } from './reject-document/reject-document.component';
import { SignProgressComponent } from './sign-document/sign-progress/sign-progress.component';
import { SignDocumentListComponent } from './sign-document/sign-document-list/sign-document-list.component';
import { SelectDocumentTypeComponent } from './select-document-type/select-document-type.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { AddDocumentGroupComponent } from './document-group-manage/add-document-group/add-document-group.component';
import { SelectStampSignComponent } from './view-document/select-stamp-sign/select-stamp-sign.component';
import { CanvasDrawComponent } from './view-document/canvas-draw/canvas-draw.component';
import { ConfirmSignOtpWithImageComponent } from './confirm-sign-otp-with-image/confirm-sign-otp-with-image.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CancelSignFlowComponent } from './cancel-sign-flow/cancel-sign-flow.component';
import { EditDocumentComponent } from './edit-document/edit-document.component';
import { SearchDocumentMineComponent } from './search-document-mine/search-document-mine.component';
import { ListSearchDocumentContractComponent } from './search-document-moha/search-document-contract-moha.component';
import { ApprovalDocumentComponent } from './approval-document/approval-document.component';
import { DeclineApproveDocumentComponent } from './decline-approve-document/decline-approve-document.component';
import { SearchDocumentSignApproveComponent } from './search-document-sign-approve/search-document-sign-approve.component';
import { SearchDocumentSignInitialComponent } from './search-document-sign-initial/search-document-sign-initial.component';
import { SetupSignFlowReceiveComponent } from './setup-sign-flow-receive/setup-sign-flow-receive.component';
import { PanelSetupSignFlowReceiveComponent } from './panel-setup-sign-flow-receive/panel-setup-sign-flow-receive.component';
import { DeclineSignDocumentComponent } from './decline-sign-document/decline-sign-document.component';
import { InitialDialogComponent } from './initial-dialog/initial-dialog.component';
import { InitialDialogSignComponent } from './initial-dialog-sign/initial-dialog-sign.component';
import { DeclineInitialSignComponent } from './decline-initial-sign/decline-initial-sign.component';
import { SignFlowDocumentComponent } from './sign-flow-document/sign-flow-document.component';
import { SignFlowDocumentV2Component } from './sign-flow-document-v2/sign-flow-document-v2.component';
import { SignContractNotifyComponent } from './search-document-mine/sign-contract-notify/sign-contract-notify.component';
import { ListSignContractNotifyComponent } from './search-document-moha/sign-contract-notify-moha/sign-contract-notify-moha.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { NotifyModule } from '../notify/notify.module';
import { DocumentFormComponent } from './add-document/document-form/document-form.component';
import { FormTemplateComponent } from './add-document/document-form/form-template/form-template.component';
import { HotTableModule } from '@handsontable/angular';
import { SelectContractFormComponent } from './add-document/select-contract-form/select-contract-form.component';
import { PreviewContractComponent } from './add-document/preview-contract/preview-contract.component';
import { FillGeneralContractInfoComponent } from './add-document/fill-general-contract-info/fill-general-contract-info.component';
import { CompleteContractFormComponent } from './add-document/complete-contract-form/complete-contract-form.component';
import { CreateContractStepComponent } from './add-document/create-contract-step/create-contract-step.component';
import { GeneralFormInfoComponent } from './add-document/general-form-info/general-form-info.component';
import { SharePartnerPickerComponent } from './share-partner-picker/share-partner-picker.component';
import { RecordPartySignComponent } from './add-document/record-party-sign/record-party-sign.component';
import { ForwardContractDialogComponent } from './forward-contract-dialog/forward-contract-dialog.component';
import { SearchDocumentMineReceiveComponent } from './search-document-mine-receive/search-document-mine-receive.component';
import { DeleteAllConfirmDialogComponent } from './delete-all-confirm-dialog/delete-all-confirm-dialog.component';
import { DeleteAllCustomersDialogComponent } from './delete-all-customers-dialog/delete-all-customers-dialog.component';
import { FootNoteComponent } from './add-document/document-form/footnote/footnote.component';
import { SignatureDialogComponent } from './add-document/signature-dialog/signature-dialog.component';
import { DocumentManagementModule } from '../document-management/document-management.module';
import { ProcedureFormComponent } from './add-document/procedure-form/procedure-form.component';
import { EkycModule } from './ekyc/ekyc.module';
import { DialogFailComponent } from './ekyc/dialog-fail/dialog-fail.component';
import { DialogSuccessComponent } from './ekyc/dialog-success/dialog-success.component';
import { PickConfigureDisplayedComponent } from './document-group-manage/pick-configure-displayed/pick-configure-displayed.component';
import { ConfigDocumentGroupComponent } from './document-group-manage/config-document-group/config-document-group.component';
import { ConfirmOnEkycSupportComponent } from './confirm-on-ekyc-support/confirm-on-ekyc-support.component';
import { ConfirmResignEkycSupportComponent } from './confirm-resign-ekyc-support/confirm-resign-ekyc-support.component';
import { MultipleSignDialogComponent } from './search-document-mine/multiple-sign-dialog/multiple-sign-dialog.component';
import { ListMultipleSignDialogComponent } from './search-document-moha/multiple-sign-dialog-moha/multiple-sign-dialog-moha.component';
import { ContractDigitizationModule } from './contract-digitization/contract-digitization.module';
import { ConfigGeneralManageComponent } from './document-group-manage/config-general-manage/config-general-manage.component';
import { AddDocumentGroupV2Component } from './document-group-manage/add-document-group-v2/add-document-group-v2.component';
import { MultipleSignFlowViewComponent } from './search-document-mine/multiple-sign-flow-view/multiple-sign-flow-view.component';
import { ListMultipleSignFlowViewComponent } from './search-document-moha/multiple-sign-flow-view-moha/multiple-sign-flow-view-moha.component';
import { TimestampListDialogComponent } from './timestamp-list-dialog/timestamp-list-dialog.component';
import { SignProgressCloudCaComponent } from './sign-document/sign-progress-cloud-ca/sign-progress-cloud-ca.component';
import { SignProgressUsbTokenComponent } from './sign-document/sign-progress-usb-token/sign-progress-usb-token.component';
import { SignBatchResultComponent } from './sign-document/sign-batch-result/sign-batch-result.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SearchWaitingConfirmDocumentComponent } from './search-waiting-confirm-document/search-waiting-confirm-document.component';
import { SignatureProcessDialogComponent } from './signature-process-dialog/signature-process-dialog.component';
import { SelectSignMethodComponent } from './sign-confirm-document/select-sign-method/select-sign-method.component';
import { SignConfirmDocumentComponent } from './sign-confirm-document/sign-confirm-document.component';
import { ApproveDocumentListComponent } from './sign-document/approve-document-list/approve-document-list.component';
import { DeclineApproveDocumentListComponent } from './sign-document/decline-approve-document-list/decline-approve-document-list.component';
import { ApproveBatchResultComponent } from './sign-document/approve-batch-result/approve-batch-result.component';
import { ApproveProgressComponent } from './sign-document/approve-progress/approve-progress.component';
import { DeclineProgressComponent } from './sign-document/decline-progress/decline-progress.component';
import { ResendContractDialogComponent } from './resend-contract-dialog/resend-contract-dialog.component';
import { WarningCancelSignConfirmationComponent } from './warning-cancel-sign-confirmation/warning-cancel-sign-confirmation.component';
import { ReSignatureProcessDialogComponent } from './re-signature-process-dialog/re-signature-process-dialog.component';
import { WarningReselectSignApproverComponent } from './warning-reselect-sign-approver/warning-reselect-sign-approver.component';
import { SmsResultDialogComponent } from './sms-result-dialog/sms-result-dialog.component';
import { AddDocumentGroupV3Component } from './add-document/general-form-info/add-document-group-v3/add-document-group-v3.component';
import { ContractDigitizationBusinessModule } from './contract-digitization-by-business/contract-digitization-business.module';
import { ImageSignConfigComponent } from './sign-flow-document/image-sign-config/image-sign-config.component';
import { SynchronizeDocumentGroupComponent } from './document-group-manage/synchronize-document-group/synchronize-document-group.component';
import { DialogSyncDocumentGroupComponent } from './document-group-manage/dialog-sync-document-group/dialog-sync-document-group.component';
import { ApproveProgressCloudCaComponent } from './sign-document/approve-progress-cloud-ca/approve-progress-cloud-ca.component';
import { ApproveProgressUsbTokenComponent } from './sign-document/approve-progress-usb-token/approve-progress-usb-token.component';
import { approveDocumentComponent } from './sign-document/approve-document/approve-document.component';
import { DeclineApprovalBatchResultComponent } from './sign-document/decline-approval-batch-result/decline-approval-batch-result.component';
import { MultiDeleteDialogComponent } from './search-document-mine/multi-delete-dialog/multi-delete-dialog.component';
import { ListMultiDeleteDialogComponent } from './search-document-moha/multi-delete-dialog-moha/multi-delete-dialog-moha.component';
import {
  SetupInternalSigningFlowComponent
} from "./add-document/general-form-info/setup-internal-signing-flow/setup-internal-signing-flow.component";
import {SetupSignFlowLotComponent} from "./setup-sign-flow-lot/setup-sign-flow-lot.component";
import {SetupSignFlowLotViewComponent} from "./setup-sign-flow-lot/setup-sign-flow-lot-view/setup-sign-flow-lot-view.component";
import {SignFlowLotListComponent} from "./setup-sign-flow-lot/sign-flow-lot-list/sign-flow-lot-list.component";
import {
  PreviewContractDocumentViewComponent
} from "./add-document/preview-contract-document-view/preview-contract-document-view.component";
import {
  SignatureProcessPopupComponent
} from "./search-document-mine/signature-process-popup/signature-process-popup.component";
import {
  ListSignatureProcessPopupComponent
} from "./search-document-moha/signature-process-popup-moha/signature-process-popup-moha.component";
import { PopupCancelFlowComponent } from "./search-document-mine/popup-cancel-flow/popup-cancel-flow.component";
import { ListPopupCancelFlowComponent } from "./search-document-moha/popup-cancel-flow-moha/popup-cancel-flow-moha.component";
import {
  SignDocumentWaitingConfirmListComponent
} from "./sign-document/sign-document-waiting-confirm-list/sign-document-waiting-confirm-list.component";
import {
  signDocumentWaitingConfirmComponent
} from "./sign-document/sign-document-waiting-confirm/sign-document-waiting-confirm.component";
import {
  SignWaitProgressUsbTokenComponent
} from "./sign-document/sign-wait-progress-usb-token/sign-wait-progress-usb-token.component";
import { SignWaitProgressComponent } from "./sign-document/sign-wait-progress/sign-wait-progress.component";
import {
  SignWaitProgressCloudCaComponent
} from "./sign-document/sign-wait-progress-cloud-ca/sign-wait-progress-cloud-ca.component";
import { UploadMultiFileAttachmentsComponent } from './add-document/upload-multi-file-attachments/upload-multi-file-attachments.component';
import { AddDocumentQuicklyComponent } from './add-document-quickly/add-document-quickly.component';
import { SaveSessionCloudCaDialogComponent } from './sign-flow-document-v2/save-session-cloud-ca-dialog/save-session-cloud-ca-dialog.component';
import { SearchDocumentProcessingComponent } from './search-document-processing/search-document-processing.component';
import { SearchNegotiateDocumentComponent } from './search-negotiate-document/search-negotiate-document.component';
import { SearchDocumentSharePartner } from './search-document-share-partner/search-document-share-partner.component';
import { ManageContractSharePartnerComponent } from './search-document-mine/manage-contract-share-partner/manage-contract-share-partner.component';
import { ListManageContractSharePartnerComponent } from './search-document-moha/manage-contract-share-partner-moha/manage-contract-share-partner-moha.component';
import { SignContractLotNotifyComponent } from './search-document-processing/sign-contract-lot-notify/sign-contract-lot-notify.component';
import { SignFlowDigitalDocumentComponent } from './sign-flow-digital-document/sign-flow-digital-document.component';
import { ImageSignDigitalConfigComponent } from './sign-flow-digital-document/image-sign-digital-config/image-sign-digital-config.component';
import { ConfirmTerminationComponent } from './search-document-mine/confirm-termination/confirm-termination.component';
import { ListConfirmTerminationComponent } from './search-document-moha/confirm-termination-moha/confirm-termination-moha.component';
import { ConfigDefaultImageComponent } from './document-group-manage/config-default-image/config-default-image.component';
import { SignDigitalDocumentListComponent } from './sign-document/sign-digital-document-list/sign-digital-document-list.component';
import { SignDigitalDocument } from './sign-document/sign-digital-document/sign-digital-document.component';
import { SignDigitalProgressCloudCaComponent } from './sign-document/sign-digital-progress-cloud-ca/sign-digital-progress-cloud-ca.component';
import { SignDigitalProgressUsbTokenComponent } from './sign-document/sign-digital-progress-usb-token/sign-digital-progress-usb-token.component';
import { SignDigitalProgressComponent } from './sign-document/sign-digital-progress/sign-digital-progress.component';
import { SignDigitalBatchResultComponent } from './sign-document/sign-digital-batch-result/sign-digital-batch-result.component';
import { ImageSignConfigLotComponent } from './sign-document/image-sign-config/image-sign-config-lot.component';
import { AddDocumentMohaComponent } from './add-document-moha/add-document-moha.component';
import { UploadMultiFileAttachmentsMohaComponent } from './add-document-moha/upload-multi-file-attachments-moha/upload-multi-file-attachments-moha.component';
import { RecordPartySignMohaComponent } from './add-document-moha/record-party-sign-moha/record-party-sign-moha.component';
import { ProcedureFormMohaComponent } from './add-document-moha/procedure-form-moha/procedure-form-moha.component';
import { PreviewContractDocumentViewMohaComponent } from './add-document-moha/preview-contract-document-view-moha/preview-contract-document-view-moha.component';
import { PreviewContractMohaComponent } from './add-document-moha/preview-contract-moha/preview-contract-moha.component';
import { FillGeneralContractInfoMohaComponent } from './add-document-moha/fill-general-contract-info-moha/fill-general-contract-info-moha.component';
import { DocumentFormMohaComponent } from './add-document-moha/document-form-moha/document-form-moha.component';
import { FormTemplateMohaComponent } from './add-document-moha/document-form-moha/form-template-moha/form-template-moha.component';
import { FootNoteMohaComponent } from './add-document-moha/document-form-moha/footnote-moha/footnote-moha.component';
import { GeneralFormInfoMohaComponent } from './add-document-moha/general-form-info-moha/general-form-info-moha.component';
import { SignatureMohaDialogComponent } from './add-document-moha/signature-dialog-moha/signature-moha-dialog.component';
import { FillLaborContractReportComponent } from './add-document-moha/fill-labor-contract-report-moha/fill-labor-contract-report-moha.component';
import { ViewDocumentMohaComponent } from './view-document-moha/view-document-moha.component';
import { CanvasDrawMohaComponent } from './view-document-moha/canvas-draw-moha/canvas-draw-moha.component';
import { SelectStampSignMohaComponent } from './view-document-moha/select-stamp-sign-moha/select-stamp-sign-moha.component';
import { ViewPropertiesDialogComponent } from './view-document-moha/view-properties-dialog/view-properties-dialog.component';
import { ViewPropertiesOriginalDialogComponent } from './view-document-moha/view-properties-original-dialog/view-properties-original-dialog.component';
import { SearchDocumentContractCompanyComponent } from './search-document-contract-company/search-document-contract-company.component';
import { SignAuthenticationPopupComponent} from './add-document-moha/sign-aunthentication-popup/sign-aunthentication-popup.component';
import { SigningDialogAuthenticationComponent} from './signing-dialog-authentication/signing-dialog-authentication.component';
import { DocumentApprovedContractComponent } from './document-approved-contract/document-approved-contract.component';
import { SignFlowDocumentApproveComponent } from './sign-flow-document-approve/sign-flow-document-approve.component';
import { SaveSessionCloudCaDialogApproveComponent } from './sign-flow-document-approve/save-session-cloud-ca-dialog/save-session-cloud-ca-dialog.component';
import { ViewDocumentMohaApproveComponent } from './view-document-moha-approve/view-document-moha-approve.component';
import { CanvasDrawMohaApproveComponent } from './view-document-moha-approve/canvas-draw-moha/canvas-draw-moha.component';
import { SelectStampSignMohaApproveComponent } from './view-document-moha-approve/select-stamp-sign-moha/select-stamp-sign-moha.component';
import { ViewPropertiesDialogApproveComponent } from './view-document-moha-approve/view-properties-dialog/view-properties-dialog.component';
import { ViewPropertiesOriginalDialogApproveComponent } from './view-document-moha-approve/view-properties-original-dialog/view-properties-original-dialog.component';
import { ViewDocumentMohaDigitalComponent } from './view-document-moha-digital/view-document-moha-digital.component';
import { CanvasDrawMohaDigitalComponent } from './view-document-moha-digital/canvas-draw-moha-digital/canvas-draw-moha-digital.component';
import { SelectStampSignMohaDigitalComponent } from './view-document-moha-digital/select-stamp-sign-moha-digital/select-stamp-sign-moha-digital.component';
import { ViewPropertiesDialogDigitalComponent } from './view-document-moha-digital/view-properties-dialog-digital/view-properties-dialog-digital.component';
import { ViewPropertiesOriginalDialogDigitalComponent } from './view-document-moha-digital/view-properties-original-dialog-digital/view-properties-original-dialog-digital.component';
import { SearchDocumentSignApproveDigitalComponent } from './search-document-sign-approve-digital/search-document-sign-approve-digital.component';
import {SearchDocumentSignDigitalComponent} from './search-document-sign-digital/search-document-sign-digital.component';
import { SignFlowDocumentDigitalComponent } from './sign-flow-document-digital/sign-flow-document-digital.component';
import { SaveSessionCloudCaDialogDigitalComponent } from './sign-flow-document-digital/save-session-cloud-ca-dialog-digital/save-session-cloud-ca-dialog-digital.component';
import { DeclineDocumentComponent } from './decline-document/decline-document.component';
import { WarningConfirmComponent } from 'src/app/shared/components/warning-confirm/warning-confirm.component'
import { SignDocumentMohaReportComponent } from './sign-document-moha-report/sign-document-moha-report.component';
import { StandardLaborContractComponent} from './standardizing-labor-contracts/standardizing-labor-contracts.component';
import  {LaborContractStandardizeExecuteComponent} from '../document/labor-contract-standardize-execute/labor-contract-standardize-execute.component'
import { NoteDialogComponent } from './standardizing-labor-contracts/note-dialog/note-dialog.component';
import { LaborContractStandardizeSearchComponent } from './labor-contract-standardize-search/labor-contract-standardize-search.component';
import { LaborContractStandardizeEmployeeComponent } from './labor-contract-standardize-employee/labor-contract-standardize-employee.component';
import { StandardizeContractListDialogComponent } from './labor-contract-standardize-execute/standardize-contract-list-dialog/standardize-contract-list-dialog.component';
import { SelectDocumentMohaDigitalComponent } from './select-document-moha-digital/select-document-moha-digital.component';

@NgModule({
  declarations: [
    AddDocumentComponent,
    AddDocumentQuicklyComponent,
    AddDocumentMohaComponent,
    StandardLaborContractComponent,
    SearchDocumentComponent,
    DocumentGroupManageComponent,
    DisplayTemplateComponent,
    PanelDocumentComponent,
    PanelDocumentViewComponent,
    SearchDocumentSignComponent,
    SearchDocumentReceiveComponent,
    ViewDocumentComponent,
    UpdateInformationDialogComponent,
    NegotiationFormComponent,
    NegotiationFormTemplateComponent,
    SubmissionComponent,
    RejectDocumentComponent,
    SignDocumentComponent,
    approveDocumentComponent,
    SignDocumentWaitingConfirmListComponent,
    signDocumentWaitingConfirmComponent,
    SignProgressComponent,
    SignWaitProgressComponent,
    ApproveProgressComponent,
    DeclineProgressComponent,
    SignDocumentListComponent,
    SelectDocumentTypeComponent,
    AddDocumentGroupComponent,
    SelectStampSignComponent,
    CanvasDrawComponent,
    ConfirmSignOtpWithImageComponent,
    CancelSignFlowComponent,
    EditDocumentComponent,
    ApprovalDocumentComponent,
    DeclineApproveDocumentComponent,
    SignDocumentWaitingConfirmListComponent,
    signDocumentWaitingConfirmComponent,
    DeclineApproveDocumentListComponent,
    SearchDocumentMineComponent,
    SearchDocumentSignApproveComponent,
    SearchDocumentSignInitialComponent,
    SetupSignFlowReceiveComponent,
    PanelSetupSignFlowReceiveComponent,
    DeclineSignDocumentComponent,
    InitialDialogComponent,
    InitialDialogSignComponent,
    DeclineInitialSignComponent,
    SignFlowDocumentComponent,
    SignFlowDigitalDocumentComponent,
    SignFlowDocumentV2Component,
    SignDocumentMohaReportComponent,
    SignContractNotifyComponent,
    PopupCancelFlowComponent,
    SignatureProcessPopupComponent,
    DocumentFormComponent,
    DocumentFormMohaComponent,
    FormTemplateComponent,
    FormTemplateMohaComponent,
    SelectContractFormComponent,
    PreviewContractComponent,
    PreviewContractMohaComponent,
    PreviewContractDocumentViewComponent,
    PreviewContractDocumentViewMohaComponent,
    FillGeneralContractInfoComponent,
    FillGeneralContractInfoMohaComponent,
    CompleteContractFormComponent,
    CreateContractStepComponent,
    GeneralFormInfoComponent,
    GeneralFormInfoMohaComponent,
    SharePartnerPickerComponent,
    RecordPartySignComponent,
    RecordPartySignMohaComponent,
    UploadMultiFileAttachmentsComponent,
    UploadMultiFileAttachmentsMohaComponent,
    ForwardContractDialogComponent,
    SearchDocumentMineReceiveComponent,
    DeleteAllConfirmDialogComponent,
    DeleteAllCustomersDialogComponent,
    FootNoteComponent,
    FootNoteMohaComponent,
    SignatureDialogComponent,
    SignatureMohaDialogComponent,
    ProcedureFormComponent,
    ProcedureFormMohaComponent,
    PickConfigureDisplayedComponent,
    ConfigDocumentGroupComponent,
    ConfirmOnEkycSupportComponent,
    ConfirmResignEkycSupportComponent,
    MultipleSignDialogComponent,
    ConfigGeneralManageComponent,
    AddDocumentGroupV2Component,
    AddDocumentGroupV3Component,
    SetupInternalSigningFlowComponent,
    SetupSignFlowLotComponent,
    SetupSignFlowLotViewComponent,
    SignFlowLotListComponent,
    MultipleSignFlowViewComponent,
    TimestampListDialogComponent,
    SignProgressCloudCaComponent,
    SignWaitProgressCloudCaComponent,
    ApproveProgressCloudCaComponent,
    SignProgressUsbTokenComponent,
    SignWaitProgressUsbTokenComponent,
    ApproveProgressUsbTokenComponent,
    SignBatchResultComponent,
    ApproveBatchResultComponent,
    DeclineApprovalBatchResultComponent,
    SearchWaitingConfirmDocumentComponent,
    SignatureProcessDialogComponent,
    SelectSignMethodComponent,
    SignConfirmDocumentComponent,
    ApproveDocumentListComponent,
    ResendContractDialogComponent,
    WarningCancelSignConfirmationComponent,
    ReSignatureProcessDialogComponent,
    WarningReselectSignApproverComponent,
    SmsResultDialogComponent,
    SynchronizeDocumentGroupComponent,
    DialogSyncDocumentGroupComponent,
    ImageSignConfigComponent,
    ImageSignDigitalConfigComponent,
    MultiDeleteDialogComponent,
    SaveSessionCloudCaDialogComponent,
    SearchDocumentProcessingComponent,
    SearchNegotiateDocumentComponent,
    SearchDocumentSharePartner,
    ManageContractSharePartnerComponent,
    SignContractLotNotifyComponent,
    ConfirmTerminationComponent,
    ConfigDefaultImageComponent,
    SignDigitalDocumentListComponent,
    SignDigitalDocument,
    SignDigitalProgressCloudCaComponent,
    SignDigitalProgressUsbTokenComponent,
    SignDigitalProgressComponent,
    SignDigitalBatchResultComponent,
    ImageSignConfigLotComponent,
    FillLaborContractReportComponent,
    ListSignContractNotifyComponent,
    ListMultipleSignDialogComponent,
    ListMultipleSignFlowViewComponent,
    ListMultiDeleteDialogComponent,
    ListSignatureProcessPopupComponent,
    ListPopupCancelFlowComponent,
    ListManageContractSharePartnerComponent,
    ListConfirmTerminationComponent,
    ListSearchDocumentContractComponent,
    ViewDocumentMohaComponent,
    CanvasDrawMohaComponent,
    SelectStampSignMohaComponent,
    ViewPropertiesDialogComponent,
    ViewPropertiesOriginalDialogComponent,
    SearchDocumentContractCompanyComponent,
    SignAuthenticationPopupComponent,
    SigningDialogAuthenticationComponent,
    ApprovedContractMohaComponent,
    DocumentApprovedContractComponent,
    SignFlowDocumentApproveComponent,
    SaveSessionCloudCaDialogApproveComponent,
    ViewDocumentMohaApproveComponent,
    CanvasDrawMohaApproveComponent,
    SelectStampSignMohaApproveComponent,
    ViewPropertiesDialogApproveComponent,
    ViewPropertiesOriginalDialogApproveComponent,
    SearchDocumentSignApproveDigitalComponent,
    ViewDocumentMohaDigitalComponent,
    CanvasDrawMohaDigitalComponent,
    SelectStampSignMohaDigitalComponent,
    ViewPropertiesDialogDigitalComponent,
    ViewPropertiesOriginalDialogDigitalComponent,
    SearchDocumentSignDigitalComponent,
    SignFlowDocumentDigitalComponent,
    SaveSessionCloudCaDialogDigitalComponent,
    DeclineDocumentComponent,
    WarningConfirmComponent,
    LaborContractStandardizeExecuteComponent,
    LaborContractStandardizeSearchComponent,
    LaborContractStandardizeEmployeeComponent,
    NoteDialogComponent,
    StandardizeContractListDialogComponent,
    SelectDocumentMohaDigitalComponent
  ],
  imports: [
    CommonModule,
    DocumentRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    MatInputModule,
    NgxMaskModule.forChild(),
    NgxExtendedPdfViewerModule,
    NgZorroAntdModule,
    SlickCarouselModule,
    MatButtonToggleModule,
    NotifyModule,
    HotTableModule,
    DocumentManagementModule,
    EkycModule,
    ContractDigitizationModule,
    ContractDigitizationBusinessModule,
    MatRadioModule,
    NzIconModule,
    NzToolTipModule,
    MatCheckboxModule
  ],
  exports: [
    DisplayTemplateComponent,
    PanelDocumentViewComponent,
    ImageSignConfigComponent,
    ImageSignDigitalConfigComponent
  ],
  entryComponents: [
    UpdateInformationDialogComponent,
    SubmissionComponent,
    RejectDocumentComponent,
    SignDocumentComponent,
    approveDocumentComponent,
    SignDocumentWaitingConfirmListComponent,
    signDocumentWaitingConfirmComponent,
    SignDocumentListComponent,
    SignProgressComponent,
    SignWaitProgressComponent,
    ApproveProgressComponent,
    DeclineProgressComponent,
    SelectDocumentTypeComponent,
    AddDocumentGroupComponent,
    SelectStampSignComponent,
    CanvasDrawComponent,
    ConfirmSignOtpWithImageComponent,
    CancelSignFlowComponent,
    ApprovalDocumentComponent,
    DeclineApproveDocumentComponent,
    SignDocumentWaitingConfirmListComponent,
    signDocumentWaitingConfirmComponent,
    DeclineApproveDocumentListComponent,
    SearchDocumentMineComponent,
    DeclineSignDocumentComponent,
    InitialDialogComponent,
    SignatureProcessDialogComponent,
    InitialDialogSignComponent,
    DeclineInitialSignComponent,
    SignContractNotifyComponent,
    PopupCancelFlowComponent,
    SignatureProcessPopupComponent,
    SignatureDialogComponent,
    SignatureMohaDialogComponent,
    SignContractNotifyComponent,
    PopupCancelFlowComponent,
    SignatureProcessPopupComponent,
    DialogFailComponent,
    DialogSuccessComponent,
    PickConfigureDisplayedComponent,
    ConfigDocumentGroupComponent,
    ConfirmOnEkycSupportComponent,
    ConfirmResignEkycSupportComponent,
    ForwardContractDialogComponent,
    DeleteAllConfirmDialogComponent,
    DeleteAllCustomersDialogComponent,
    MultipleSignDialogComponent,
    ConfigGeneralManageComponent,
    DeleteAllCustomersDialogComponent,
    AddDocumentGroupV2Component,
    AddDocumentGroupV3Component,
    SetupInternalSigningFlowComponent,
    SetupSignFlowLotComponent,
    SetupSignFlowLotViewComponent,
    SignFlowLotListComponent,
    TimestampListDialogComponent,
    SignProgressCloudCaComponent,
    SignWaitProgressCloudCaComponent,
    ApproveProgressCloudCaComponent,
    SignProgressUsbTokenComponent,
    SignWaitProgressUsbTokenComponent,
    ApproveProgressUsbTokenComponent,
    SelectSignMethodComponent,
    ApproveDocumentListComponent,
    ResendContractDialogComponent,
    WarningCancelSignConfirmationComponent,
    ReSignatureProcessDialogComponent,
    WarningReselectSignApproverComponent,
    SmsResultDialogComponent,
    DialogSyncDocumentGroupComponent,
    SaveSessionCloudCaDialogComponent,
    SearchDocumentProcessingComponent,
    SearchNegotiateDocumentComponent,
    SearchDocumentSharePartner,
    ManageContractSharePartnerComponent,
    SignContractLotNotifyComponent,
    ConfirmTerminationComponent,
    ConfigDefaultImageComponent,
    SignDigitalDocumentListComponent,
    SignDigitalDocument,
    SignDigitalProgressCloudCaComponent,
    SignDigitalProgressUsbTokenComponent,
    SignDigitalProgressComponent,
    SignDigitalBatchResultComponent,
    ImageSignConfigLotComponent,
    ListSignContractNotifyComponent,
    ListMultipleSignDialogComponent,
    ListMultipleSignFlowViewComponent,
    ListMultiDeleteDialogComponent,
    ListSignatureProcessPopupComponent,
    ListPopupCancelFlowComponent,
    ListManageContractSharePartnerComponent,
    ListConfirmTerminationComponent,
    ListSearchDocumentContractComponent,
    CanvasDrawMohaComponent,
    SelectStampSignMohaComponent,
    ViewPropertiesDialogComponent,
    ViewPropertiesOriginalDialogComponent,
    SearchDocumentContractCompanyComponent,
    SignAuthenticationPopupComponent,
    SigningDialogAuthenticationComponent,
    SaveSessionCloudCaDialogApproveComponent,
    ViewDocumentMohaApproveComponent,
    CanvasDrawMohaApproveComponent,
    SelectStampSignMohaApproveComponent,
    ViewPropertiesDialogApproveComponent,
    ViewPropertiesOriginalDialogApproveComponent,
    ViewPropertiesDialogDigitalComponent,
    ViewPropertiesOriginalDialogDigitalComponent,
    DeclineDocumentComponent,
    WarningConfirmComponent,
    SaveSessionCloudCaDialogDigitalComponent,
    LaborContractStandardizeSearchComponent,
    LaborContractStandardizeEmployeeComponent,
    NoteDialogComponent,
    StandardizeContractListDialogComponent,
    SelectDocumentMohaDigitalComponent
  ]
})
export class DocumentModule { }
